import './NotFound.scss';

const NotFound = (props) => {
  return (
    <div className='notfound'>Désolé, cette page n'existe pas</div>
  );
}

export default NotFound;